import Config from "./Config";

export const endpoints = {
  login: `${Config.apiUrl}/auth/loginClient`,
  logout: `${Config.apiUrl}/auth/signout`,
  ordersEndpoint: `${Config.apiUrl}/order`,
  getProductsSearch: `${Config.apiUrl}/product/search`,
  orderOfferEndpoint: `${Config.apiUrl}/orderOffer`,
  getPublicProductsSearch: `${Config.apiUrl}/orderOffer/searchProducts`,
  getPublicPaymentMethods: `${Config.apiUrl}/orderOffer/paymentMethods`,
  getOrderOfferForClient: `${Config.apiUrl}/orderOffer/order`,
  getPublicTransportOptions: `${Config.apiUrl}/orderOffer/transportOptions`,
  rolesEndpoint: `${Config.apiUrl}/role`,
  orderStatus: `${Config.apiUrl}/orderStatus`,
  getProducts: `${Config.apiUrl}/product`,
  syncWordPressData: `${Config.apiUrl}/product/sync`,
  syncWordPressDataOrders: `${Config.apiUrl}/order/sync`,
  emailTemplatesEndpoint: `${Config.apiUrl}/emailTemplate`,
  duplicateOrder: `${Config.apiUrl}/order/duplicate/`,
  contactEndpoint: `${Config.apiUrl}/contact`,
  getDashboardSummaryContacts: `${Config.apiUrl}/contact/dashboard`,
  getAvailableContacts: `${Config.apiUrl}/contact/available`,
  getTakenContacts: `${Config.apiUrl}/contact/taken`,
  associateAgentWithContact: `${Config.apiUrl}/contact/associateAgent`,
  updateOrderNotes: `${Config.apiUrl}/order/notes`,
  updateContactNotes: `${Config.apiUrl}/contact/notes`,
  transportOption: `${Config.apiUrl}/transportOption`,
  whatsAppMetaUrl: "https://graph.facebook.com/v19.0/",
  user: {
    main: `${Config.apiUrl}/user`,
    autocomplete: `${Config.apiUrl}/user/filter`,
    dataset: `${Config.apiUrl}/user/dataset`,
  },
  media: {
    main: `${Config.apiUrl}/media`,
    delete: `${Config.apiUrl}/media/delete`,
    folder: `${Config.apiUrl}/media/folder`,
    public: `${Config.apiUrl}/media/public`,
  },
  clientCategory: {
    main: `${Config.apiUrl}/clientCategory`,
  },
  audit: {
    main: `${Config.apiUrl}/audit`,
  },
  oblio: {
    main: `${Config.apiUrl}/oblio`,
    syncProducts: `${Config.apiUrl}/oblio/syncProducts`,
    managementNomenclator: `${Config.apiUrl}/oblio/managementNomenclator`,
    cancel: `${Config.apiUrl}/oblio/cancel`,
    generateInvoice: `${Config.apiUrl}/oblio/invoice/generate`,
  },
  whatsApp: {
    main: `${Config.apiUrl}/whatsApp`,
    waba: `${Config.apiUrl}/whatsApp/waba`,
    createPhoneNumber: `${Config.apiUrl}/whatsApp/createPhoneNumber`,
    registerPhoneNumber: `${Config.apiUrl}/whatsApp/registerPhoneNumber`,
    template: `${Config.apiUrl}/whatsApp/template`,
    uploadMedia: `${Config.apiUrl}/whatsApp/uploadMediaContentForHeader`,
    message: `${Config.apiUrl}/whatsApp/message`,
    templateMessage: `${Config.apiUrl}/whatsApp/templateMessage`,
    image: `${Config.apiUrl}/whatsApp/image`,
    sendFileMessage: `${Config.apiUrl}/whatsApp/sendFileMessage`,
  },
  conversation: {
    main: `${Config.apiUrl}/conversation`,
    markConversationAsRead: `${Config.apiUrl}/conversation/markConversationAsRead`,
    unreadConversations: `${Config.apiUrl}/conversation/unreadConversations`,
    associate: `${Config.apiUrl}/conversation/associate`,
  },
  setting: {
    main: `${Config.apiUrl}/setting/`,
    orderSettings: `${Config.apiUrl}/setting/orderSettings/`,
    orderSettingsNumber: `${Config.apiUrl}/setting/orderSettingsNumber/`,
    contact: `${Config.apiUrl}/setting/contactSettings/`,
    clients: `${Config.apiUrl}/setting/clientsSettings/`,
    updateClientsSettings: `${Config.apiUrl}/setting/clients/`,
  },
  documentation: {
    main: `${Config.apiUrl}/documentation`,
  },
  client: {
    main: `${Config.apiUrl}/client`,
    search: `${Config.apiUrl}/client/search/`,
    periodicityNames: `${Config.apiUrl}/client/periodicityNames`,
    import: `${Config.apiUrl}/client/import`,
    getANAFData: `${Config.apiUrl}/client/anaf`,
    updateUserData: `${Config.apiUrl}/client/updateUserData`,
    generateUserAccount: `${Config.apiUrl}/client/generateUserAccount`,
    paymentInfo: `${Config.apiUrl}/client/payment-info`,
    instructors: `${Config.apiUrl}/client/instructors`,
    activateSubscription: `${Config.apiUrl}/client/activate-subscription`,
  },
  exams: `${Config.apiUrl}/exams`,
  task: {
    main: `${Config.apiUrl}/task`,
    duplicate: `${Config.apiUrl}/task/duplicate`,
    subtask: `${Config.apiUrl}/task/subtask`,
  },
  alert: {
    main: `${Config.apiUrl}/alert`,
  },
  alertPerEntity: {
    main: `${Config.apiUrl}/alertPerEntity`,
  },
  notifications: {
    main: `${Config.apiUrl}/notifications`,
    markAsRead: `${Config.apiUrl}/notifications/markAsRead`,
    forClient: `${Config.apiUrl}/notifications/forClient`,
    send: `${Config.apiUrl}/notifications/send`,
    sendDrivingLesson: `${Config.apiUrl}/notifications/send-driving-lesson`,
  },
  courses: `${Config.apiUrl}/courses`,
  statistics: `${Config.apiUrl}/statistics`,
  modules: `${Config.apiUrl}/modules`,
  examSets: {
    main: `${Config.apiUrl}/examSets`,
    activeWithQuestionDistinct: `${Config.apiUrl}/examSets/activeWithQuestionDistinct`,
  },
  examQuestions: {
    set: `${Config.apiUrl}/examQuestions/set`,
    question: `${Config.apiUrl}/examQuestions/question`,
    commonWrongQuestions: `${Config.apiUrl}/examQuestions/clientCommonWrongQuestions`,
    availableCategories: `${Config.apiUrl}/examQuestions/availableCategories`,
    simulateByProduct: `${Config.apiUrl}/examQuestions/simulateByProduct`,
  },
  clientProgress: `${Config.apiUrl}/clientProgress`,
  liveLegislation: `${Config.apiUrl}/live-legislation/upcoming-events`,
  examQuestionsReports: `${Config.apiUrl}/exam-questions-reports`,
  resetPassword: `${Config.apiUrl}/auth/reset-password`,
  forgotPassword: `${Config.apiUrl}/auth/forgot-password`,
  orderTypes: `${Config.apiUrl}/order-type`, // Endpoint for fetching order types
  workPoints: `${Config.apiUrl}/workPoints`, // Endpoint for fetching work point prices
  payments: {
    main: `${Config.apiUrl}/payments`,
    generatePaymentUrl: `${Config.apiUrl}/payments/generate-payment-url`,
    getPaymentStatus: `${Config.apiUrl}/payments/get-payment-status`,
    createPayment: `${Config.apiUrl}/payments/create-payment-transaction`,
  },
  certificateExams: `${Config.apiUrl}/certificate-exams`,
  hours: {
    main: `${Config.apiUrl}/hours`,
    byClientInstructors: `${Config.apiUrl}/hours/by-client-instructors`,
    orderSummary: `${Config.apiUrl}/hours/order-summary`,
    supplimentaryHours: `${Config.apiUrl}/hours/supplimentaryHours`,
  },
  subscriptions: `${Config.apiUrl}/subscriptions`,
  purchases: {
    main: `${Config.apiUrl}/purchases`,
    generatePaymentUrl: `${Config.apiUrl}/purchases/generate-payment-url`,
    getPaymentStatus: `${Config.apiUrl}/purchases/get-payment-status`,
    createPayment: `${Config.apiUrl}/purchases/create-payment-transaction`,
  },
  clientActiveOrders: `${Config.apiUrl}/order/client/:clientId/active`,
};

export const localUrlEnum: Record<string, string> = {
  login: "/login",
  users: "/users?",
  clients: "/clients?",
  reports: "/reports",
  sales: "/sales",
  orders: "/orders?",
  settings: "/settings",
  messages: "/messages",
  orderStatus: "/orderStatus?",
  order: "/orders/order",
  client: "/clients/client",
  marketing: "/marketing",
  product: "/products/product",
  supportTickets: "/supportTickets",
  mainRoute: "/",
  tasks: "/tasks",
  dashboard: "/dashboard",
  statistics: "/statistics",
  whatsAppPhoneNumbers: "/whatsApp/phoneNumbers",
  whatsAppTemplates: "/whatsApp/templates",
  whatsAppTemplate: "/whatsApp/template",
  pageNotFound: "*",
  renderChildren: "",
  logs: "/logs",
  alerts: "/alerts",
  clientRegistration: "/client-registration",
  products: "/products?",
  contacts: "/contacts",
  emailTemplates: "/emailTemplates?",
  orderOfferPasswordCheck: "/orderOfferPasswordCheck",
  orderOffer: "/orderOffer",
  orderOfferConfirmation: "/orderOfferConfirmation",
  clientAccount: "/client-account",
  courses: "/courses",
  questionnaire: "/questionnaire",
  examQuestions: "/examQuestions",
  liveLegislation: "/live",
  commonWrongQuestions: "/commonWrongQuestions",
  simulateExam: "/simulate-exam",
  certificateExams: "/certificate-exams",
  resetPassword: "/reset-password/:token/:email",
  forgotPassword: "/forgot-password",
  publicRegistration: "/register",
  paymentStatus: "/payment-status",
  subscriptionExpired: "/subscription-expired",
  drivingSessionScheduling: "/driving-session-scheduling",
  chooseExamsSimulation: "/choose-exams-simulation",
  chooseExamProduct: "/choose-exam-product",
  purchaseAddons: "/purchase-addons",
};

export const basicOperationsEnum = {
  create: "/create",
  update: "/update",
  delete: "/delete",
  import: "/import",
  export: "/export",
};

export const pathParams = {
  optionalId: "/:id?",
  orderId: "/:orderId",
  page: "/:page",
  courseId: "/:courseId",
  examSetId: "/:examSetId",
};

export const foldersNames = {
  usersProfiles: "usersProfiles/",
};
export const ragEndpoints = { ragApi: "/chat" };
